// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import type React from 'react';
import { Helmet } from 'react-helmet-async';
import { Outlet } from 'react-router-dom';

import { StyledContent } from './Root.styles';
import { Layout } from '../../ui';

import SystemAlerts from '../../../containers/SystemAlerts';
import SystemSpinner from '../../../containers/SystemSpinner';

function HelmetWrapper(): JSX.Element {
  return <Helmet defer={false} encodeSpecialCharacters htmlAttributes={{ lang: 'en' }} />;
}

type RootLayoutProps = {
  header: React.ReactNode;
};

export function RootLayout({ header }: RootLayoutProps) {
  return (
    <Layout className="h-100" data-test-id="root-app">
      <HelmetWrapper />
      {header}
      <StyledContent>
        <Outlet />
      </StyledContent>
      <SystemAlerts />
      <SystemSpinner />
    </Layout>
  );
}
